<template>
  <div
    class="success-logout modal"
    v-if="logout"
    role="alert"
  >
    <div class="success-logout__container">
      <div class="success-logout__text">
        <div class="success-logout__text--header">
          {{ $t('logout.success.header') }}
        </div>
        <p v-html="$t('logout.success.text')" />
        <contact-info :is-success-logout="true" />
      </div>
      <div class="success-logout__buttons">
        <div class="button--accept">
          <button
            class="button--accept-all button button--alt"
            v-html="$t('logout.success.button')"
            @click="closeOverlay"
            :aria-label="$t('global.modal.close.button.aria.label')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import cookieMonster from '../../utilities/js/cookieMonster/cookieMonster.js';
  import ContactInfo from "../contactInfo/contactInfo";

  export default {
    props: {
      cookieName: {
        type: String,
        default: 'LOGOUT'
      },
    },
    components: {
      ContactInfo
    },
    data() {
      return {
        logout: false
      }
    },
    created() {
      this.setInitialValue();
    },
    methods: {
      setInitialValue() {
        if (cookieMonster.get(this.cookieName)) {
          this.$store.state.isOverlayVisible = true;
          this.logout = true;
          cookieMonster.delete(this.cookieName)
        }
      },
      closeOverlay() {
        this.logout = false;
        this.$store.state.isOverlayVisible = false;
      }
    }
  };

</script>
